import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { User } from 'src/app/models/user';
import { AppFunctionGroup } from 'src/app/models/app-function-group';
import { UserAppFunctionGroupMap } from 'src/app/models/user-app-function-group-map';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ElementRef } from '@angular/core';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { UntypedFormControl } from '@angular/forms';
import { HostListener } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Settings } from '../../../services/settings';
import { SendInviteComponent } from './send-invite/send-invite.component';
import { DatePipe } from '@angular/common';
import { UserEntity } from 'src/app/models/user-entity';
import { DwUtils } from '../../../components/utils/dw-utils';
import { AgenciesService } from '../../../services/agencies.service';
import { AgencyTableComponent } from './agencytable/agencytable.component';
import { SecurityComponent } from '../security/security.component';
import { SecurityGroup } from "../../../models/security-group";
import { SecurityService } from "../../../services/security.service";
import { UserSecurityGroupMap } from "../../../models/user-security-group-map";
import { TransactionHistoryComponent } from 'src/app/components/transaction-history/transaction-history';

@Component({
	selector: 'app-usermanagement',
	templateUrl: './usermanagement.component.html',
	styleUrls: ['./usermanagement.component.css']
})
export class UsermanagementComponent implements OnInit {

	public visibleAdd = false;
	public visibleModify = false;
	public visibleDelete = false;
	public visibleSecurity = false;
	public displaySecurityDialog = false;
	public visibleInvite = false;
	public agencyActive = false;
	public groupsActive = false;

	public selectedTabIndex: number | null = 0;

	public isEditing = false;
	public isAdd = false;
	public formContent: UntypedFormGroup;
	public Idx = -1;
	public selectedRecord: User;
	public records = Array<User>();
	public displayedColumns: string[] = ['id', 'username', 'name', 'email', 'status', 'invitationCount', 'securityGroupsList', 'securityOverride', 'lastLogin'];
	public dataSource: MatTableDataSource<User>;
	public pagination: string;
	public formTitle = 'User Management';
	public result: boolean;
	public disabledFlag = true;
	public strErr = '';
	public selectedFilterStatus = '2';
	public selectedFilterIdx: number | null = -1;
	public activeCellId = -1;
	public enableSecurity = true;

	public displayInvitationDlg = false;
	public displayAgencyDlg = false;
	public displayAppMouseOverDlg = false;
	public securityGroupToolTipText: string;

	public agencyList: any;
	public agencyIdx: number | null = -1;
	public agencyName: string;
	public _agencyId: number;
	public _agencyView = false;

	public setMessage: string | null = '<Click the set button>';

	public availableSecurityGroupsList = Array<SecurityGroup>();
	public assignedSecurityGroupsList: string[];

	public contentClassWithBanner = 'dwtable-container';
	public contentClassWithoutBanner = 'dwtable-container-without-header';
	public contentClassName = 'dwtable-container';

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('txtFilter', { static: true }) txtFilter: ElementRef;
	@ViewChild('username', { static: true }) username: ElementRef;
	@ViewChild('fullname', { static: true }) fullname: ElementRef;
	@ViewChild('password', { static: true }) password: ElementRef;
	@ViewChild('email', { static: true }) email: ElementRef;

	@ViewChild('send_invite', { static: true }) sendInvite: SendInviteComponent;
	@ViewChild('agencyTableDlg', { static: true }) agencyTableDlg: AgencyTableComponent;
	@ViewChild('dlgSecurity', { static: true }) dlgSecurity: SecurityComponent;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	@Output() closeAgencyEvent: EventEmitter<any> = new EventEmitter<any>();

	@Input() set agencyId(value: number) {
		this._agencyId = value;
		if (this._agencyView) {
			this.queryRecords();
		}
	}
	@Input() set agencyView(value: boolean) {
		this._agencyView = value;
		if (this._agencyId) {
			this.queryRecords();
		}
	}

	constructor(private userService: UserService,
		private securityService: SecurityService,
		private agencyService: AgenciesService,
		public dialog: MatDialog, private datePipe: DatePipe) {
		this.formContent = new UntypedFormGroup({
			id: new UntypedFormControl('id'),
			username: new UntypedFormControl('username'),
			password: new UntypedFormControl('password'),
			name: new UntypedFormControl('name'),
			status: new UntypedFormControl('status'),
			email: new UntypedFormControl('email'),
			agency: new UntypedFormControl('agency'),
		});
		/* start out disabled in the detail form */
		this.formContent.get('id').setValue('');
		this.formContent.get('username').setValue('');
		this.formContent.get('name').setValue('');
		this.formContent.get('password').setValue('');
		this.formContent.get('status').setValue('');
		this.formContent.get('email').setValue('');
		this.formContent.get('agency').setValue('');
		this.agencyName = '';
		this.formContent.disable();
		this.agencyIdx = 0;
		this.selectedFilterIdx = 0;
	}
	public ngOnInit() {
		// Now let's set the access privilege level
		if ((!this._agencyView && Settings.getInstance().hasPrivilege('SETTINGS_USERS', "WRITE")) ||
			(this._agencyView && Settings.getInstance().hasPrivilege('AGENCY_DETAILS_USER_LIST', "WRITE"))) {
			this.visibleAdd = true;
			this.visibleModify = true;
			this.visibleSecurity = true;
		}
		if ((!this._agencyView && Settings.getInstance().hasPrivilege('SETTINGS_USERS_INVITE', "EXECUTE"))
			|| (this._agencyView && Settings.getInstance().hasPrivilege('AGENCY_DETAILS_INVITE_USER', "EXECUTE"))) {
			this.visibleInvite = true;
		}
		if ((this._agencyView && Settings.getInstance().hasPrivilege('AGENCY_DETAILS_USER_AGENCY_SET', "WRITE"))
			|| (!this._agencyView && Settings.getInstance().hasPrivilege('SETTINGS_USERS_AGENCY_ASSOCIATION', "EXECUTE"))) {
			this.agencyActive = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_USERS_GROUP_MANAGEMENT', "EXECUTE")) {
			this.groupsActive = true;
		}
		/*** do not allow delete of user records ***/
		this.visibleDelete = false;

		if (!this._agencyView && !this._agencyId) {
			this.queryRecords();
		}
		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
	}
	setAccessPrivilegesForAgencyView() {
		if (this._agencyView) {
			this.visibleAdd = Settings.getInstance().hasPrivilege('AGENCY_DETAILS_ADD_USER', "EXECUTE");
			this.visibleModify = Settings.getInstance().hasPrivilege('AGENCY_DETAILS_EDIT_USER', "EXECUTE");
		}
	}

	@HostListener('matSortChange', ['$event'])
	public onSortChange(event) {

		if (this.selectedRecord?.id > 0) {
			this.unSelectRow(true);
		}
	}
	public applyFilter(filterValue: string) {
		if (this.isEditing) return;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		this.unSelectRow(false);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	public clearFilter() {
		if (this.isEditing) return;
		this.dataSource.filter = '';

		this.unSelectRow(false);
		this.setPagination(-1, this.dataSource.filteredData.length);
		DwUtils.setFocus('txtFilter');
	}
	private queryRecords() {
		this.setAccessPrivilegesForAgencyView();
		this.agencyService.getAllAgenciesOrderByName().subscribe(

			(result) => {
				this.agencyList = result;
				DwUtils.setFocus('txtFilter');
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching the Available Function Groups');
			});

		this.securityService.getAllSecurityGroups().subscribe(
			(data) => {
				this.availableSecurityGroupsList = data;
				this.availableSecurityGroupsList.sort((a, b) => a.name.localeCompare(b.name));
				this.setViewBasedOnAccessRights();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching the Available Function Groups');
			}
		);

		if (this._agencyView === false) {
			this.queryAllUsers();
		} else {
			this.userService.getAgencyUsers(this._agencyId).subscribe(
				(data) => {
					Settings.getInstance().usersList = data;
					for (const rec of data) {
						rec.displayStatus = this.getStatusDescription(rec.status);
					}

					this.records = data;
					this.dataSource = new MatTableDataSource(this.records);
					this.onChangeStatusFilterValue();
					this.dataSource.sort = this.sort;
					this.setPagination(-1, this.dataSource.filteredData.length);
					this.setViewBasedOnAccessRights();
				},
				(error) => {
					Settings.getInstance().handleError(error, 'fetching users list');
				}
			);
		}

	}
	private queryAllUsers() {
		this.userService.getAllUsers(true).subscribe(
			(data) => {
				Settings.getInstance().usersList = data;
				for (const rec of data) {
					rec.displayStatus = this.getStatusDescription(rec.status);
					rec['securityGroupsList'] = rec.securityGroups
						? rec.securityGroups.map(g => g.name).join(', ')
						: '';

					rec['securityOverride'] = Array.isArray(rec.securityTargetElements)
						? rec.securityTargetElements.map(o => o.name).join(', ')
						: '';

				}

				this.records = data;
				this.dataSource = new MatTableDataSource(this.records);
				this.onChangeStatusFilterValue();
				this.dataSource.sort = this.sort;
				this.setPagination(-1, this.dataSource.filteredData.length);

			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching users list');
			}
		);
	}
	public invitationStatusLabeler(row): string {
		/** note we should use the invitation count here not the status - this way
		 * we can test for a more granular view of the invitation status plus
		 * it works better for sorting on that column **/
		return Settings.invitationStatusLabeler(row);
	}
	public lastLoginLabeler(row): string {

		if (row.lastLogin === null || row.lastLogin === undefined)
			return 'Never';

		return row.lastLogin.toString();
	}
	public onRowClicked(SR: User) {
		if (this.isEditing) return;
		this.selectedRecord = SR;
		//this.records = this.dataSource.connect().value;
		this.Idx = this.dataSource.connect().value.indexOf(this.selectedRecord);
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public unSelectRow(withZero: boolean) {
		/* if (this.isEditing) return; */
		this.Idx = -1;
		this.selectedRecord = new User(withZero);
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);

	}
	public tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) return;
		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.records[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.records[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}

		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public displayDetail(record: User) {

		if (record.id === null) {
			return;
		}

		this.assignedSecurityGroupsList = [];
		this.history.onShowHandler('Users', 'id', record.id.toString());
		this.securityService.getSecurityGroupsByUser(record.id).subscribe(
			(data) => {
				this.assignedSecurityGroupsList = [];
				for (const rec of data) {
					try {
						this.assignedSecurityGroupsList.push(this.getSecurityGroupRecordById(rec['id']).name);
					}
					catch (e) {
						//Do nothing since Admion grooup might be kept disabled for Agency Users view
					}
				}

				this.formContent.get('name').setValue(record.name);
				this.formContent.get('password').setValue(record.password);
				this.formContent.get('username').setValue(record.username);
				this.formContent.get('email').setValue(record.email);
				this.formContent.get('id').setValue(record.id);

				if (record.agencyId === undefined) {
					return;
				}

				if (record.agencyId < 1) {
					this.agencyName = this.setMessage;
				}
				else {
					this.agencyName = this.returnAgencyName(record.agencyId);
				}

				if (record.status === 1) {
					this.formContent.get('status').setValue('Active');
				} else {
					this.formContent.get('status').setValue('InActive');
				}
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching getAppFunctionGroup records by user id.');
			}
		);
	}
	public addModifyRecord(isAdd: boolean) {
		this.isEditing = true;
		this.formContent.enable();
		this.formContent.get('id').disable();
		this.disabledFlag = false;
		this.selectedTabIndex=0;

		if (isAdd === true) {
			this.isAdd = true;

			this.unSelectRow(true);
			this.selectedRecord.id = 0;
			this.formContent.get('status').setValue('Active');
			this.formContent.get('id').setValue('0');
			this.formContent.get('email').setValue('');

			if (this._agencyView) {
				this.agencyName = this.returnAgencyName(this._agencyId);
			} else {
				this.agencyName = '<Click the Set Button>';
				this.agencyName = this.setMessage;
			}

			DwUtils.setFocus('username');

		} else {
			this.isAdd = false;
			this.formContent.get('username').disable();
			DwUtils.setFocus('fullname');
		}
	}
	public removeRecord() {
		const message = 'Remove this record - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.userService.deleteUser(this.selectedRecord.id).subscribe(
					(data) => {
						console.log('deleted record.');
						this.clearDetail();
						this.queryRecords();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					}
				);
			}
		});
	}
	public clearDetail(): void {
		this.formContent.get('name').setValue('');
		this.formContent.get('password').setValue('');
		this.formContent.get('username').setValue('');
		this.formContent.get('email').setValue('');
		this.formContent.get('agency').setValue('');
		this.formContent.get('id').setValue('');
		this.formContent.get('status').setValue('');

	}
	public validateRecord(): boolean {
		this.strErr = '';

		if (this.formContent.get('username').value.length === 0) {
			this.strErr = 'Error: A user name/login is required';
			DwUtils.setFocus('username');
			return false;
		}

		if (DwUtils.validUserName(this.formContent.get('username').value) === false) {
			this.strErr = 'Error: A user name can only contain letters and numbers';
			DwUtils.setFocus('username');
			return false;
		}

		if (this.isAdd && this.getUserRecordByUserName(this.formContent.get('username').value) !== null) {
			this.strErr = 'Error: This username already exists - please choose a different one';
			DwUtils.highlightFocus('username');
			return false;
		}
		if (this.getUserRecordByEmail(this.formContent.get('email').value, this.formContent.get('username').value) !== null) {
			this.strErr = 'Error: This email address already exists - please choose a different one';
			DwUtils.highlightFocus('email');
			return false;
		}
		if (!this.isblankOrUndefined(this.formContent.get('name').value)) {
			this.strErr = 'Error: A full name is required';
			DwUtils.setFocus('name');
			return false;
		}

		if (!this.isblankOrUndefined(this.formContent.get('email').value)) {
			this.strErr = 'Error: A valid email is required';
			DwUtils.setFocus('email');
			return false;
		}

		if (DwUtils.validEmailAddress(this.formContent.get('email').value) === false) {
			this.strErr = 'Error: The Email is in an invalid format - please check';
			DwUtils.highlightFocus('email');
			return false;
		}

		if (this.agencyName === this.setMessage) {
			this.strErr = 'Error: an agency must be associated with this user';
			this.displayAgencyDlg = true;
			this.agencyTableDlg.doInitialize(0);
			return false;
		}

		return true;
	}
	public isblankOrUndefined(val: any): boolean {

		if (val === undefined || val === null || val === '') {
			return false;
		}
		return true;
	}
	public submitRecord() {

		if (this.validateRecord() === false) {
			return;
		}

		this.isEditing = false;

		const selectedSecurityGroupsList: SecurityGroup[] = [];
		for (let i = 0; i < this.assignedSecurityGroupsList.length; i++) {
			for (const recFunction of this.availableSecurityGroupsList) {
				if (recFunction.name === this.assignedSecurityGroupsList[i]) {
					selectedSecurityGroupsList.push(recFunction);
				}
			}
		}

		if (this.isAdd) {
			// Let's add a new user now!
			const newUser = new User();
			newUser.id = this.formContent.get('id').value;
			newUser.username = DwUtils.downshift(this.formContent.get('username').value);
			newUser.password = this.formContent.get('password').value;
			newUser.email = this.formContent.get('email').value;
			newUser.name = DwUtils.capitalize(this.formContent.get('name').value);
			newUser.agencyId = this.returnAgencyId(this.agencyName);
			if (this.formContent.get('status').value === 'Active') {
				newUser.status = 1;
			} else {
				newUser.status = 0;
			}
			newUser.securityGroups = selectedSecurityGroupsList;
			//newUser.appFunctions = selectedAppFunctionsList;
			let userEntity = new UserEntity(newUser);
			this.userService.createUser(userEntity).subscribe(
				(data) => {
					if (data !== undefined && data !== null && data.id > 0) {
						const userSecurityGroupMapList: any[] = [];
						//	const userSecurityMapList: any[] = [];
						for (const rec of newUser.securityGroups) {
							const temp: UserSecurityGroupMap = new UserSecurityGroupMap();
							userSecurityGroupMapList.push(rec.id);
						}

						this.securityService.createUserSecurityGroupMaps(data.id, userSecurityGroupMapList).subscribe(
							(data1) => {
								this.updateRecordsList(data, 'add');
							},
							(error) => {
								Settings.getInstance().handleError(error, 'Creating User record' +
									' for the user');
							});
					}
				},
				(error) => {
					Settings.getInstance().handleError(error);
				}
			);
		} else {
			// here, let's update the edited record
			// don't allow update of the username.
			// this.selectedRecord.username = this.formContent.get('username').value;
			this.selectedRecord.password = this.formContent.get('password').value;
			this.selectedRecord.email = this.formContent.get('email').value;
			this.selectedRecord.name = DwUtils.capitalize(this.formContent.get('name').value);
			this.selectedRecord.agencyId = this.returnAgencyId(this.agencyName);
			this.selectedRecord.securityGroups = selectedSecurityGroupsList;

			if (this.formContent.get('status').value === 'Active') {
				this.selectedRecord.status = 1;
			} else {
				this.selectedRecord.status = 0;
			}
			const userEntity = new UserEntity(this.selectedRecord);
			this.userService.updateUser(userEntity).subscribe(
				(data) => {

					const userSecurityGroupMapList: any[] = [];
					for (const rec of this.selectedRecord.securityGroups) {
						// const temp: UserSecurityGroupMap = new UserSecurityGroupMap();
						userSecurityGroupMapList.push(rec.id);
					}

					this.securityService.createUserSecurityGroupMaps(this.selectedRecord.id, userSecurityGroupMapList).subscribe(
						(data1) => {
							this.updateRecordsList(this.selectedRecord, 'update');
						},
						(error) => {
							Settings.getInstance().handleError(error, 'Creating App Function Maps' +
								' for the user');
						});
				},
				(error) => {
					Settings.getInstance().handleError(error, 'Updating user');
				});
		}
		this.isEditing = false;
		this.formContent.disable();
		this.disabledFlag = true;
	}
	public updateRecordsList(user: any, addUpdate: string) {
		if (addUpdate === 'add') {
			user.displayStatus = this.getStatusDescription(user.status);
			user['securityGroupsList'] = user.securityGroups
				? user.securityGroups.map(g => g.name).join(', ')
				: '';

			this.records.unshift(user);
			this.dataSource = new MatTableDataSource(this.records);
			this.onRowClicked(user);
			const elem = document.getElementById('userTableId');
			elem.scrollTop = 0;
		} else {
			const idx = this.records.findIndex(s => s.id === user.id);
			if (idx > -1) {
				user.displayStatus = this.getStatusDescription(user.status);
				user['securityGroupsList'] = user.securityGroups
					? user.securityGroups.map(g => g.name).join(', ')
					: '';
				this.records[idx] = user;
			}
		}
		this.isEditing = false;
	}

	public cancelSubmitRecord() {
		this.strErr = '';
		this.displayDetail(this.selectedRecord);
		this.isEditing = false;
		this.formContent.disable();
		this.disabledFlag = true;
		DwUtils.setFocus('txtFilter');
	}
	public getUserRecordByUserName(username: string): User {

		if (username === undefined) {
			return null;
		}
		const rec = this.records.find(s => s.username === username);

		if (rec === undefined) {
			return null;
		}
		return rec;
	}
	public getUserRecordByEmail(email: string, username: string): User {

		if (email === undefined) {
			return null;
		}
		const rec = this.records.find(s => s.email === email && s.username !== username);

		if (rec === undefined) {
			return null;
		}

		return rec;

	}
	public groupSelectionChanged(): any {

		if (this.assignedSecurityGroupsList === undefined) {
			return;
		}

		for (let i = 0; i < this.assignedSecurityGroupsList.length; i++) {
			const groupRecord: SecurityGroup = this.getSecurityGroupRecord(this.assignedSecurityGroupsList[i]);
			if (groupRecord === null) {
				continue;
			}
		}

	}
	public getSecurityGroupRecord(param: string): SecurityGroup {

		for (const rec of this.availableSecurityGroupsList) {
			if (rec.name === param) {
				return rec;
			}
		}
		return null;
	}
	public getSecurityGroupRecordById(id: number): SecurityGroup {

		for (const rec of this.availableSecurityGroupsList) {
			if (rec.id === id) {
				return rec;
			}
		}
		return null;
	}
	public onChangeStatusFilterValue(unSelectCurrentRow = true) {

		const dataTemp: User[] = [];

		if (unSelectCurrentRow === true) {
			this.unSelectRow(true);
		}
		/*** inactive records ***/
		if (this.selectedFilterStatus === '0') {

			for (const rec of this.records) {
				if (rec.status === 0) {
					dataTemp.push(rec);
				}
			}
			/*** active records ***/
		} else if (this.selectedFilterStatus === '1') {

			for (const rec of this.records) {
				if (rec.status === 1) {
					dataTemp.push(rec);
				}
			}
			/*** all records ***/
		} else if (this.selectedFilterStatus === '2') {
			for (const rec of this.records) {
				dataTemp.push(rec);
			}
		}

		this.dataSource = new MatTableDataSource(dataTemp);
		this.dataSource.sort = this.sort;
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	public statusCellReceivedFocus(id) {
		this.activeCellId = id;
	}
	public onStatusChange() {
		this.selectedRecord.status = this.selectedRecord.status == 1 ? 0 : 1;
		if (this.selectedRecord.status === 1) {
			this.selectedRecord.displayStatus = 'Active';
		} else {
			this.selectedRecord.displayStatus = 'InActive';
		}

		const userEntity: UserEntity = new UserEntity(this.selectedRecord);

		this.userService.updateUser(userEntity).subscribe(
			(data) => {
				// refresh the list.
				const idx = this.records.findIndex(s => s.username === this.selectedRecord.username);
				this.records[idx].status = this.selectedRecord.status;
				this.dataSource = new MatTableDataSource(this.records);
				this.onChangeStatusFilterValue();
				this.dataSource.sort = this.sort;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'updating active status for user');
			});
	}
	public openInvitationDialog() {
		this.displayInvitationDlg = true;
		this.sendInvite.doInitialize(this.records.filter(s => s.status === 1));
	}
	public cancelClickedFromSendInvite() {
		this.displayInvitationDlg = false;
	}
	public invitationSentHandler() {
		this.queryRecords();
		this.displayInvitationDlg = false;
	}
	public getStatusDescription(inpVal: number): string {
		if (inpVal === undefined) {
			return '';
		}
		if (inpVal === 1) {
			return 'Active';
		}

		return 'InActive';
	}
	public returnAgencyId(name: string): number {

		if ((this.agencyList === undefined) || (this.agencyList.length === 0)) {
			return 0;
		}

		let agencyId = this.agencyList.find(s => s.agencyName === name)?.id;

		if (agencyId === undefined) {
			agencyId = 0;
		}
		return agencyId

	}
	public returnAgencyName(id: number): string {
		if ((id === undefined) || (id === null)) {
			return '';
		}
		if (id === 0) {
			return this.setMessage;
		}
		let agencyName = this.agencyList.find(s => s.id === id).agencyName;
		return agencyName;
	}
	public showAgencyDlg(): void {
		this.displayAgencyDlg = true;
		this.agencyTableDlg.doInitialize(this.selectedRecord.agencyId);
	}
	public agencySelectedHandler(event: any): void {

		this.selectedRecord.agencyId = event.id;
		this.agencyName = this.returnAgencyName(this.selectedRecord.agencyId);

		this.displayAgencyDlg = false;
	}
	public setViewBasedOnAccessRights() {

		if (this._agencyView) { // For agency view, we need to hide Administration group access, agency edits etc.
			try {
				this.availableSecurityGroupsList =
					this.availableSecurityGroupsList.filter((item) => !(item.id === 1 && item.name === "Administration"));
			} catch (e) { }
		}
		DwUtils.setFocus('txtFilter');
	}
	public closeAgencyViewDialog(): void {
		this.closeAgencyEvent.emit();
	}
	public doFunctionMouseOver(name: string): void {

		this.securityGroupToolTipText =
			this.returnStaticSecurityGroupDesc(name);

		this.displayAppMouseOverDlg = true;
	}
	public returnStaticSecurityGroupDesc(inp: string): string {
		if (inp === undefined) {
			return '';
		}
		switch (inp) {
			case 'Dashboard Group':
				return 'Provides access to dashboards and reports'
			case 'Administration':
				return 'System-wide administration features - access to all areas';
			case 'Request Group':
				return 'Regular agency users for managing cases and requests'
			case 'Agencies Administrators':
				return 'Set up agency users, services and agency parameters';
		}
		return '';
	}
	public launchSecurityDialog(): void {

		if (this.isEditing === true || this.visibleSecurity === false) {
			return;
		}
		this.dlgSecurity.loadSecurityTargets();
		this.displaySecurityDialog = true;

	}
	public doSecuritySubmit(event): void {

		this.displaySecurityDialog = false;
		this.selectedRecord['securityOverride'] = event;
	}
	public doTabChange(event): void {
		if (event.index === 1 && this.selectedRecord) {
			this.history.onShowHandler('Users', 'id', this.selectedRecord.id.toString());
		}
	}
}
